import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { Comment } from '../../actions'

// Load comments for photo
export const loadPhotoComments = (
  action$: ActionsObservable<Action>,
  _store: Store<State>,
  { logger, apiClient }: Dependencies
) =>
  action$
    .filter(Comment.loadPhotoComments.started.match)
    .do(action => {
      logger.info(`Loading comments ${action.payload}`)
    })
    .mergeMap(action =>
      apiClient
        .getPhotoComments(action.payload)
        .map(comments =>
          Comment.loadPhotoComments.done({
            params: action.payload,
            result: comments
          })
        )
        .catch(error => {
          logger.error('Fail to load user, error=', error)
          return Rx.Observable.of(
            Comment.loadPhotoComments.failed({
              params: action.payload,
              error
            })
          )
        })
    )

export default combineEpics<Epic>(loadPhotoComments)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/operations/loadPhotoComments.ts